// Central lightweight message dictionary (German defaults)
// Extend or replace by importing and merging in components if needed.
export const MESSAGES = Object.freeze({
  no_data: 'Keine Daten verfügbar!',
  no_week_data: 'Keine Daten für diese Woche',
  no_month_data: 'Keine Daten für diesen Monat',
  no_activity: 'Keine Aktivitäten',
  no_potentials: 'Keine Potentiale',
  no_contacts: 'Keine Kontakte',
  loading_placeholder: 'Noch keine Daten geladen',
  empty_reporting: 'Keine Reporting Daten',
  no_reviews_week: 'in Arbeit',
  not_found: 'Nicht gefunden',
  search_empty: 'Keine Ergebnisse für die Suche',
});

export function resolveMessage(key, fallback){
  return MESSAGES[key] || fallback || key;
}
